import React from "react";
import { Redirect } from "react-router-dom";
import { observer } from "mobx-react";
import { withStore } from "../../hocs";
import { EnumUserType } from "../../enum/EnumUserType";

type AdminRouteGuardProps = {
    children: React.ReactNode;
    store?: any;
};

// @ts-ignore
@withStore
@observer
export class AdminRouteGuard extends React.Component<AdminRouteGuardProps> {
    render() {
        const { store, children } = this.props;
        const isAuth = Boolean(store?.mainStore?.isAuth);
        const userType = store?.mainStore?.userType;
        const hasAdminAccess = userType === EnumUserType.adminAuth || userType === EnumUserType.root;

        if (!isAuth || !hasAdminAccess) {
            return <Redirect to="/404" />;
        }

        return <>{children}</>;
    }
}
